import styles from "./Section3.module.scss";

export const Section3 = function () {
  return (
    <section id="benefits" className={`${styles.section3Wrapper} cc--component-container`}>
      <div className={styles.section3Container}>
        <h3>ON COMPLETION OF THIS PROGRAM, YOU&rsquo;LL WALK AWAY WITH:</h3>
        <div className={styles.section3Content}>
          <div className={styles.firstCol}>
            <span>1</span>
          </div>
          <div className={styles.secondCol}>
            <p>
              A practical grounding in artificial intelligence (AI) and its business applications, equipping you with
              the knowledge and confidence you need to <strong>transform your organization</strong> into an innovative,
              efficient, and sustainable company of the future.
            </p>
          </div>
          <div className={styles.firstCol}>
            <span>2</span>
          </div>
          <div className={styles.secondCol}>
            <p>
              The ability to lead <strong>informed, strategic decision-making and augment business performance</strong>{" "}
              by integrating key AI management and leadership insights into the way your organization operates.
            </p>
          </div>
          <div className={styles.firstCol}>
            <span>3</span>
          </div>
          <div className={styles.secondCol}>
            <p>
              A sophisticated understanding of what generative AI is and how it works — including its applications and
              limitations across various industries — and insights into how to{" "}
              <strong>adapt to and work with generative AI to keep ahead of the curve</strong>.
            </p>
          </div>
          <div className={styles.firstCol}>
            <span>4</span>
          </div>
          <div className={styles.secondCol}>
            <p>
              A <strong>powerful dual-perspective</strong> from two MIT schools — the MIT Sloan School of Management and
              the MIT Computer Science and Artificial Intelligence Laboratory — offering you a sound conceptual
              understanding of AI technologies through a business lens.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
